import React from "react";
import PropTypes from "prop-types";

//
import Moment from "react-moment";

function MobileEarningList({ items }) {
  return (
    <div className="box-type">
      {items.map((item) => (
        <div className="items">
          <header>
            <p>
              <i className="las la-arrow-right text-success"></i>
              {item.description}
            </p>

            <p className="text-success" style={{ minWidth: "max-content" }}>
              {item.amount} {item.amountType === "point" ? "Points" : "Fiats"}
            </p>
          </header>
          <div className="content zebra">
            <div className="item">
              <p>Status</p>
              <p
                className={`fw-bolder ${
                  item.status === "pending" ? "text-warning" : "text-success"
                }`}
              >
                {item.status}
              </p>
            </div>

            <div className="item">
              <p>Date</p>
              <p>
                <span className="fw-bolder text-black">
                  <Moment utc format="MMM DD, YYYY, ">{item.created_at}</Moment>
                </span>
                <span>
                  <Moment utc format="hh:mm">{item.created_at}</Moment>
                </span>
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

MobileEarningList.propTypes = {
  items: PropTypes.array.isRequired,
};

export default MobileEarningList;
